module.exports = __webpack_public_path__ + "img/sales.576c905f.svg";